/* eslint-disable */

import { useState, useEffect, useRef } from "react";
import { alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import {
    Box,
    IconButton,
    InputBase,
    Popper,
    Paper,
    FormControl,
    FormControlLabel,
    Checkbox,
    Divider,
    FormGroup
} from "@mui/material";
import { useTheme } from "@emotion/react";
import FilterIcon from "@mui/icons-material/FilterList";
import { KeywordsSelectURL, Select, VSelect } from "./Custom Inputs/Select";
import { useDispatch, useSelector } from "react-redux";
import { BasicTooltip } from "./StyledComponents";
import {
    updateQuickSearch,
    updateQuickSearchFilter,
    clearSearchResults,
} from "../../js/redux/actions/userPref";
import { useHistory } from "react-router-dom";
import { t } from "react-i18nify";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { randomID } from "../../routers/MenuRouter";
import { historyPush } from "../../js/utils/genericMethods";
import Axios from "axios";
import { fetchNewEntityTreeView } from "../../js/utils/backend";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { VDateOnlyPicker } from "./Custom Inputs/CustomInputs";
import { useForm, FormProvider } from "react-hook-form";

const defaultSearchCategories = [
    { label: "Entities", submenu: [], value: "Entities", checked: true },
    { label: "Documents", onlykeywords: [{label:"Only In Keywords", value:"OnlyInKeywords", checked:false}], value: "Documents", checked: true },
    { label: "Stations", value: "Stations", checked: true },
    { label: "Zones", value: "Zones", checked: true },
    { label: "Samplings", value: "Samplings", checked: true },
];

const searchCriterias = [
    { label: "Match case", value: "MatchCase", checked: false },
    { label: "Match whole words", value: "MatchWholeWords", checked: false },
    { label: "Match special characters", value: "MatchAccented", checked: false },
    { label: "Sound like", value: "SoundLike", checked: false },
    { label: "Keywords Only", value: "KeywordsOnly", selected:[], checked: false },
    { label: "Date", value: "Date", startDate:null, endDate:null, checked: false },
    { label: "File Type", value: "FileType", selected:[], checked: false },
    { label: "State", value: "State", selected:[], checked: false },
    { label: "Category", value: "Category", selected:[], checked: false },
    { label: "Entity status", value: "EntityStatus", selected: null, checked: false }
];

const SearchBar = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [newEntityTreeView, setNewEntityTreeView] = useState(false);
    const token = useSelector(state => state.auth.Token);

    const {
        MetaCompanyManager,
        CompanyManager,
        HoldingManager,
        EntityManagerEntityIDs,
        EditorEntityIDs,
        ContributorEntityIDs,
        UploaderEntityIDs,
        BranchManagerEntityIDs,
        ViewerEntityIDs,
        ExternalEntityIDs,
        EntityManager,
        Editor,
        Contributor,
        Uploader,
        BranchManager,
        Viewer,
        External
    } = useSelector(state => state.auth);
    
    const entityIds =
        EntityManager ? EntityManagerEntityIDs :
        Editor ? EditorEntityIDs :
        Contributor ? ContributorEntityIDs :
        Uploader ? UploaderEntityIDs :
        BranchManager ? BranchManagerEntityIDs :
        Viewer ? ViewerEntityIDs :
        External ? ExternalEntityIDs :
        [];

    const searchInput = useSelector(state => state.userPref.QuickSearch);
    const [searchText, setSearchText] = useState(searchInput);
    const history = useHistory();
    const methods = useForm();
    const quickSearchFilter = useSelector(
        state => state.userPref.QuickSearchFilter
    );
    const lastFilterCriteriasUpdate = useSelector(
        state => state.userPref.LastFilterCriteriasUpdate
    );
    const openPopper = Boolean(anchorEl);
    const id = openPopper ? "simple-popper" : undefined;

    const handlePopper = event => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedFileType, setSelectedFileType] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);

    const [searchCategories, setSearchCategories] = useState(
        quickSearchFilter?.SearchCategories || defaultSearchCategories
    );

    const [criterias, setCriterias] = useState(
        quickSearchFilter?.SearchCriterias || searchCriterias
    );

    const maxResultOptions = [
        { label: "5", value: 5 },
        { label: "10", value: 10 }, 
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
    ];

    useEffect(() => {
        if (
            quickSearchFilter?.SearchCategories &&
            JSON.stringify(quickSearchFilter.SearchCategories) !== JSON.stringify(searchCategories)
        ) {
            setSearchCategories(quickSearchFilter.SearchCategories);
        }
        if (
            quickSearchFilter?.SearchCriterias &&
            JSON.stringify(quickSearchFilter.SearchCriterias) !== JSON.stringify(criterias)
        ) {
            setCriterias(quickSearchFilter.SearchCriterias);
        }
    }, [quickSearchFilter?.SearchCategories, quickSearchFilter?.SearchCriterias]);

    useEffect(() => {
        if (quickSearchFilter?.SearchCriterias) {
            setCriterias(quickSearchFilter.SearchCriterias);
        }
    }, [quickSearchFilter?.SearchCriterias, lastFilterCriteriasUpdate]);

    const searchBarRefresh = useSelector(state => state.userPref.GlobalSearchBarRefresh);
    const updatedBranchesAndCountries = useSelector(
        state => state.userPref.LastBranchCountryTreeUpdate
    );

    function updateCategories(e, branchCode = null) {
        let updated;
        if (newEntityTreeView) {
            updated = searchCategories?.map((obj) => {
                if (obj.label === e.target.name) {
                    const checked = e.target.checked;
                    const updatedObj = { ...obj, checked };
                    if (obj.label === "Entities" && obj.submenu) {
                        updatedObj.submenu = obj.submenu.map((branch) => ({
                            ...branch,
                            Checked: checked,
                            Countries: branch.Countries.map((country) => ({
                                ...country,
                                Checked: checked,
                                OTEntities: country.OTEntities.map((entity) => ({
                                    ...entity,
                                    Checked: checked,
                            })),
                        })),
                        }));
                    }
                    if (obj.label === "Documents") {
                        const updatedCriterias = criterias.map(criteria => {
                            if (["File Type", "Category", "State", "Keywords Only"].includes(criteria.label)) {
                                if (!checked) {
                                    // Uncheck and disable when Documents is unchecked
                                    const resetCriteria = {
                                        ...criteria,
                                        checked: false,
                                        disabled: true
                                    };
                                    // Reset selected values
                                    if (criteria.value === "KeywordsOnly") resetCriteria.selected = [];
                                    if (criteria.value === "FileType") resetCriteria.selected = [];
                                    if (criteria.value === "Category") resetCriteria.selected = [];
                                    if (criteria.value === "State") resetCriteria.selected = [];
                                    return resetCriteria;
                                } else {
                                    // Enable when Documents is checked
                                    return {
                                        ...criteria,
                                        disabled: false
                                    };
                                }
                            }
                            return criteria;
                        });
                        setCriterias(updatedCriterias);
                        
                        // Reset form values when Documents is unchecked
                        if (!checked) {
                            setSelectedFileType(null);
                            setSelectedState(null);
                            setSelectedCategory(null);
                            methods.reset({
                                fileType: null,
                                state: null,
                                category: null
                            });
                        }
                    }
                    return updatedObj;
                }else if (obj.label === "Documents" && obj.onlykeywords) {
                    const updatedKeywords = obj.onlykeywords.map(keyword =>
                        keyword.label === e.target.name
                            ? { ...keyword, checked: e.target.checked }
                            : keyword
                    );
                    return { ...obj, onlykeywords: updatedKeywords };
                }
                else if (obj.submenu) {
                    const updatedSubmenu = obj.submenu.map((branch) => {
                        if (branch.BranchCode === e.target.name) {
                            const checked = e.target.checked;
                            return {
                                ...branch,
                                Checked: checked,
                                Countries: branch.Countries.map(country => ({
                                    ...country,
                                    Checked: checked,
                                    OTEntities: country.OTEntities.map(entity => ({
                                        ...entity,
                                        Checked: checked
                                    }))
                                }))
                            };
                        }
                        const updatedCountries = branch.Countries.map((country) => {
                            if (branch.BranchCode === branchCode && country.CountryName === e.target.name) {
                                const checked = e.target.checked;
                                return {
                                    ...country,
                                    Checked: checked,
                                    OTEntities: country.OTEntities.map((entity) => ({
                                        ...entity,
                                        Checked: checked,
                                    })),
                                };
                            }
                            const updatedEntities = country.OTEntities.map((entity) =>
                                entity.Label === e.target.name
                                    ? { ...entity, Checked: e.target.checked }
                                    : entity
                            );
                            const isCountryChecked = updatedEntities.some(
                                (entity) => entity.Checked
                            );
                            return {
                                ...country,
                                OTEntities: updatedEntities,
                                Checked: isCountryChecked,
                            };
                        });

                        const isBranchChecked = updatedCountries.some(
                            (country) => country.Checked
                        );

                        return {
                            ...branch,
                            Countries: updatedCountries,
                            Checked: isBranchChecked,
                        };
                    });

                    const isCategoryChecked = updatedSubmenu.some(
                        (branch) => branch.Checked
                    );

                    return {
                        ...obj,
                        checked: isCategoryChecked,
                        submenu: updatedSubmenu,
                    };
                } else {
                    return obj;
                }
            });
        } else {
            updated = searchCategories?.map(obj => {
                if (obj.label === e.target.name) {
                    const updatedObj = { ...obj, checked: e.target.checked };
                    if (obj.label === "Entities" && updatedObj.submenu) {
                        for (let i = 0; i < updatedObj.submenu.length; i++) {
                            updatedObj.submenu[i].checked = updatedObj.checked;
                        }
                    }
                    if (obj.label === "Documents") {
                        const updatedCriterias = criterias.map(criteria => {
                            if (["File Type", "Category", "State", "Keywords Only"].includes(criteria.label)) {
                                if (!e.target.checked) {
                                    // Uncheck and disable when Documents is unchecked
                                    const resetCriteria = {
                                        ...criteria,
                                        checked: false,
                                        disabled: true
                                    };
                                    // Reset selected values
                                    if (criteria.value === "KeywordsOnly") resetCriteria.selected = [];
                                    if (criteria.value === "FileType") resetCriteria.selected = [];
                                    if (criteria.value === "Category") resetCriteria.selected = [];
                                    if (criteria.value === "State") resetCriteria.selected = [];
                                    return resetCriteria;
                                } else {
                                    // Enable when Documents is checked
                                    return {
                                        ...criteria,
                                        disabled: false
                                    };
                                }
                            }
                            return criteria;
                        });
                        setCriterias(updatedCriterias);
                        
                        // Reset form values when Documents is unchecked
                        if (!e.target.checked) {
                            setSelectedFileType(null);
                            setSelectedState(null);
                            setSelectedCategory(null);
                            methods.reset({
                                fileType: null,
                                state: null,
                                category: null
                            });
                        }
                    }
                    return updatedObj;
                } 
                else if (obj.label === "Documents" && obj.onlykeywords) {
            const updatedKeywords = obj.onlykeywords.map(keyword =>
                keyword.label === e.target.name
                    ? { ...keyword, checked: e.target.checked }
                    : keyword
            );
            return { ...obj, onlykeywords: updatedKeywords };
        }else if (obj.submenu) {
                    let counter = 0;
                    const updatedSubmenu = obj.submenu.map(subObj =>
                        subObj.label === e.target.name
                            ? { ...subObj, checked: e.target.checked }
                            : subObj
                    );
                    for (let i = 0; i < updatedSubmenu.length; i++) {
                        if (!updatedSubmenu[i].checked) {
                            counter++;
                        }
                    }
                    if (counter === updatedSubmenu.length) {
                        return { ...obj, checked: false, submenu: updatedSubmenu };
                    }

                    return { ...obj, checked: true, submenu: updatedSubmenu };
                } else {
                    return obj;
                }
            });
        }

        setSearchCategories(updated);
    }

    const searchCategoriesImmediate = useSelector(state => state.userPref.SearchCategoriesImmediate);

    const maxResultCountRedux = useSelector(state => state.userPref.MaxResultCount);

    const [maxResultCount, setMaxResultCount] = useState(
        typeof maxResultCountRedux === "number" ? maxResultCountRedux : 100
    );

    useEffect(() => {
        if (typeof maxResultCountRedux === "number") {
            setMaxResultCount(maxResultCountRedux);
        }
    }, [maxResultCountRedux]);

    function updateMaxResultCount(event, option) {
        setMaxResultCount(option.value);
        dispatch(updateMaxResultCount(option.value));
    }

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetchNewEntityTreeView(token);
            const config = {
                headers: { Authorization: "Bearer " + token }
            };
            searchCategories[0].submenu = [];
            setNewEntityTreeView(result.data);
            if(result.data){
                const url = "OTEntity/getSearchSubMenuEntities";
                if(MetaCompanyManager || CompanyManager || HoldingManager){
                    Axios.post(url, [], config).then(response => {
                        searchCategories[0].submenu = response.data;
                    })
                }
                else if(entityIds!==null && entityIds.length>1){
                    Axios.post(url, entityIds, config).then(response => {
                        searchCategories[0].submenu = response.data;
                    })
                }
            }
            else{
                const url = "OTEntity/getSearchEntities";
                if(MetaCompanyManager || CompanyManager || HoldingManager){
                    Axios.post(url, [], config).then(response => {
                        for(let i=0; i<response.data.length; i++){
                            let data = { "checked": true, "label": response.data[i].Label, "value": response.data[i].Value};
                            searchCategories[0].submenu.push(data);
                        }
                    })
                }
                else if(entityIds!==null && entityIds.length>1){
                    Axios.post(url, entityIds, config).then(response => {
                        for(let i=0; i<response.data.length; i++){
                            let data = { "checked": true, "label": response.data[i].Label, "value": response.data[i].Value};
                            searchCategories[0].submenu.push(data);
                        }
                    })
                }
            }
        }
        fetchData();
        // eslint-disable-next-line
    }, [searchBarRefresh, updatedBranchesAndCountries])

    const initializedCountries = useRef(false);

    useEffect(() => {
        // Only run if submenu is loaded and countries are present, and not already initialized
        if (
            searchCategories[0] &&
            searchCategories[0].submenu &&
            searchCategories[0].submenu.length > 0 &&
            !initializedCountries.current
        ) {
            let needsUpdate = false;
            const updated = searchCategories.map((cat) => {
                if (cat.label === "Entities" && cat.submenu) {
                    const newSubmenu = cat.submenu.map(branch => {
                        const newCountries = branch.Countries
                            ? branch.Countries.map(country => {
                                if (!country.Checked) needsUpdate = true;
                                return { ...country, Checked: true };
                            })
                            : [];
                        return { ...branch, Countries: newCountries };
                    });
                    return { ...cat, submenu: newSubmenu };
                }
                return cat;
            });
            if (needsUpdate) {
                setSearchCategories(updated);
            }
            initializedCountries.current = true;
        }
        // eslint-disable-next-line
    }, [searchCategories[0]?.submenu]);

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed && searchCategories && maxResultCount && criterias) {
            const quickSearchFilter = {
                SearchCategories: searchCategories,
                // MaxResultCount: maxResultCount,
                SearchCriterias: criterias
            };
            dispatch(updateQuickSearchFilter(quickSearchFilter));
        }

        return () => (isSubscribed = false);
    }, [searchCategories, maxResultCount, criterias, dispatch]);

    const handleSearch = event => {
        dispatch(updateQuickSearch(event.target.value));
        setSearchText(event.target.value);
    };

    function executeSearch(e) {
        if (e.key === "Enter") { 
            const latestCriterias = quickSearchFilter?.SearchCriterias || criterias;
            const latestCategories = searchCategoriesImmediate || searchCategories;
            let input = searchText;
            input = input.replaceAll("/","-");
            const selectedKeywords = latestCriterias.find(c => c.value === "KeywordsOnly")?.selected;
            const keywordsSelected = selectedKeywords?.length > 0;
            const fileTypeChecked = latestCriterias.find(c => c.value === "FileType")?.checked;
            const stateChecked = latestCriterias.find(c => c.value === "State")?.checked;
            const categoryChecked = latestCriterias.find(c => c.value === "Category")?.checked;
            const rawStartDate = latestCriterias.find(c => c.value === "Date")?.startDate || startDate;
            const rawEndDate = latestCriterias.find(c => c.value === "Date")?.endDate || endDate;
            const formattedStartDate = rawStartDate ? dayjs(rawStartDate).format("DD-MM-YYYY") : "";
            const formattedEndDate = rawEndDate ? dayjs(rawEndDate).format("DD-MM-YYYY") : "";
            const dateSelected = formattedStartDate || formattedEndDate;

            const cleanInput = (str) => {
                return str
                    .replace(/\|\s+/g, '|')
                    .replace(/\s+$/g, '');
            };

            if(fileTypeChecked){
                let selectedFileType = latestCriterias.find(c => c.value === "FileType")?.selected;
                if(selectedFileType?.value){
                    selectedFileType = selectedFileType.value;
                }
                if(selectedFileType?.startsWith(".")) selectedFileType = selectedFileType.substring(1);
                if(input.includes("|")){
                    const match = searchInput.match(/\.(.*?)\./);
                    if (match && match[1]) {
                        input = input.replace(`.${match[1]}.`, "");
                        input = input.replace(/\s+/g, ' ').trim();
                        if(input[input.length - 1] === "|") input = input.slice(0, -1);
                    }
                    if(input.includes("|"))
                        input += " ." + selectedFileType + ".";
                    else
                        input += "|." + selectedFileType + ".";
                } else {
                    input += "|." + selectedFileType + ".";
                }
            }
            if(stateChecked){
                let selectedState = latestCriterias.find(c => c.value === "State")?.selected;
                if(selectedState?.value){
                    selectedState = selectedState.value;
                }
                if(input.includes("|")){
                    const match = searchInput.match(/\$(.*?)\$/);
                    if (match && match[1]) {
                        input = input.replace(`$${match[1]}$`, "");
                        input = input.replace(/\s+/g, ' ').trim();
                        if(input[input.length - 1] === "|") input = input.slice(0, -1);
                    }
                    if(input.includes("|"))
                        input += " $" + selectedState + "$";
                    else
                        input += "|$" + selectedState + "$";
                } else {
                    input += "|$" + selectedState + "$";
                }
            }
            if(categoryChecked){
                let selectedCategory = latestCriterias.find(c => c.value === "Category")?.selected;
                if(selectedCategory?.value){
                    selectedCategory = selectedCategory.value;
                }
                if(input.includes("|")){
                    const match = searchInput.match(/\<(.*?)\>/);
                    if (match && match[1]) {
                        input = input.replace(`<${match[1]}>`, "");
                        input = input.replace(/\s+/g, ' ').trim();
                        if(input[input.length - 1] === "|") input = input.slice(0, -1);
                    }
                    if(input.includes("|"))
                        input += " <" + selectedCategory + ">";
                    else
                        input += "|<" + selectedCategory + ">";
                } else {
                    input += "|<" + selectedCategory + ">";
                }
            }
            if(dateSelected){
                const selectedDates = formattedStartDate + ";" + formattedEndDate;
                if (input.includes("|")) {
                    const match = searchInput.match(/\:(.*?)\:/);
                    if (match && match[1]) {
                        input = input.replace(`:${match[1]}:`, "");
                        input = input.replace(/\s+/g, ' ').trim();
                        if(input[input.length - 1] === "|") input = input.slice(0, -1);
                    }
                    if(input.includes("|"))
                        input += " :" + selectedDates + ":";
                    else
                        input += "|:" + selectedDates + ":";
                } else {
                    input += "|:" + selectedDates + ":";
                }
            }
            if(keywordsSelected){
                if(input.includes("|")){
                    const match = searchInput.match(/\*(.*?)\*/);
                    if (match && match[1]) {
                        input = input.replace(`*${match[1]}*`, "");
                        input = input.replace(/\s+/g, ' ').trim();
                        if(input[input.length - 1] === "|") input = input.slice(0, -1);
                    }
                    if(input.includes("|"))
                        input += " *" + selectedKeywords?.map(k => k.Value).join(";") + "*";
                    else
                        input += "|*" + selectedKeywords?.map(k => k.Value).join(";") + "*";
                } else {
                    input += "|*" + selectedKeywords?.map(k => k.Value).join(";") + "*";
                }
            }

            dispatch(updateQuickSearchFilter({
                ...quickSearchFilter,
                SearchCriterias: latestCriterias,
                SearchCategories: latestCategories
            }))
            // Clear search results cache when starting a new search (same as Get Results button)
            dispatch(clearSearchResults());
            historyPush(history, `/searchResults/${(input === null || input === "") ? "[all]" : input}/${randomID()}`);
        }
    }

    const handlePopperClicAway = () => {
        setAnchorEl(null);
    };

    const [expandedBranches, setExpandedBranches] = useState([]);

    useEffect(() => {
        const subscription = methods.watch((values) => {
            setCriterias(prev =>
                prev.map(item =>
                    item.value === "Category"
                        ? { ...item, selected: values.category }
                        : item.value === "FileType"
                        ? { ...item, selected: values.fileType }
                        : item.value === "State"
                        ? { ...item, selected: values.state }
                        : item
                )
            );
        });
        return () => subscription.unsubscribe && subscription.unsubscribe();
    }, [methods]);

    useEffect(() => {
        const subscription = methods.watch((values) => {
            if (values.fileType) {
                setSelectedFileType(values.fileType);
            }
            if (values.state) {
                setSelectedState(values.state);
            }
            if (values.category) {
                setSelectedCategory(values.category);
            }
        });
        return () => subscription.unsubscribe && subscription.unsubscribe();
    }, [methods]);

    return (
        <Box
            component="div"
            sx={{
                position: "relative",
                borderRadius: "20px",
                border: 1,
                borderColor: alpha(theme.palette.primary.main, 0.15),
                margin: "8px 16px 8px 8px",
                width: { xs: "100%", md: 340 },
            }}
        >
            <Box
                component="div"
                sx={{
                    height: 1,
                    position: "absolute",
                    pointerEvents: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                }}
            ></Box>
            <InputBase
                value={searchText ?? ""}
                onChange={handleSearch}
                onKeyDown={executeSearch}
                fullWidth
                sx={{
                    color: "inherit",
                    "& .MuiInputBase-input": {
                        padding: theme.spacing(1, 1, 1, 0),
                        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
                        transition: theme.transitions.create("width"),
                    },
                }}
                endAdornment={
                    <>
                        <BasicTooltip
                            title={t("common.AdvancedSearchCriteria")}
                            placement="top"
                        >
                            <IconButton onClick={e => {
                                let input = searchText;
                                const selectedKeywords = criterias.find(c => c.value === "KeywordsOnly")?.selected;
                                const keywordsSelected = selectedKeywords?.length > 0;
                                const fileTypeChecked = criterias.find(c => c.value === "FileType")?.checked;
                                const stateChecked = criterias.find(c => c.value === "State")?.checked;
                                const categoryChecked = criterias.find(c => c.value === "Category")?.checked;
                                const rawStartDate = criterias.find(c => c.value === "Date")?.startDate || startDate;
                                const rawEndDate = criterias.find(c => c.value === "Date")?.endDate || endDate;
                                const formattedStartDate = rawStartDate ? dayjs(rawStartDate).format("DD-MM-YYYY") : "";
                                const formattedEndDate = rawEndDate ? dayjs(rawEndDate).format("DD-MM-YYYY") : "";
                                const dateSelected = formattedStartDate || formattedEndDate;
                                input = input.replaceAll("/","-");
                                if(fileTypeChecked){
                                    let selectedFileType = criterias.find(c => c.value === "FileType")?.selected;
                                    if(selectedFileType.value){
                                        selectedFileType = selectedFileType.value
                                    }
                                    if(selectedFileType.startsWith((".")))
                                        selectedFileType = selectedFileType.substring(1);
                                    if(input.includes("|")){
                                        const match = searchInput.match(/\.(.*?)\./);
                                        if (match && match[1]) {
                                            input = input.replace(`.${match[1]}.`, "");
                                            input = input.replace(/\s+/g, ' ').trim();
                                            if(input[input.length - 1] === "|")
                                                input = input.slice(0, -1);
                                        }
                                        if(input.includes("|"))
                                            input += " ." + selectedFileType+".";
                                        else
                                            input += "|." + selectedFileType+".";
                                    }
                                    else{
                                        input += "|." + selectedFileType+".";
                                    }
                                }
                                if(stateChecked){
                                    let selectedState = criterias.find(c => c.value === "State")?.selected;
                                    if(selectedState.value){
                                        selectedState = selectedState.value
                                    }
                                    if(input.includes("|")){
                                        const match = searchInput.match(/\$(.*?)\$/);
                                        if (match && match[1]) {
                                            input = input.replace(`$${match[1]}$`, "");
                                            input = input.replace(/\s+/g, ' ').trim();
                                            if(input[input.length - 1] === "|")
                                                input = input.slice(0, -1);
                                        }
                                        if(input.includes("|"))
                                            input += " $" + selectedState+"$";
                                        else
                                            input += "|$" + selectedState+"$";
                                    }
                                    else{
                                        input += "|$"+selectedState+"$";
                                    }
                                }
                                if(categoryChecked){
                                    let selectedCategory = criterias.find(c => c.value === "Category")?.selected;
                                    if(selectedCategory.value){
                                        selectedCategory = selectedCategory.value
                                    }
                                    if(input.includes("|")){
                                        const match = searchInput.match(/\<(.*?)\>/);
                                        if (match && match[1]) {
                                            input = input.replace(`<${match[1]}>`, "");
                                            input = input.replace(/\s+/g, ' ').trim();
                                            if(input[input.length - 1] === "|")
                                                input = input.slice(0, -1);
                                        }
                                        if(input.includes("|"))
                                            input += " <" + selectedCategory+">";
                                        else
                                            input += "|<" + selectedCategory+">";
                                    }
                                    else{
                                        input += "|<"+selectedCategory+">";
                                    }
                                }
                                if(dateSelected){
                                    const selectedDates = formattedStartDate + ";" + formattedEndDate;
                                    if (input.includes("|")) {
                                        const match = searchInput.match(/\:(.*?)\:/);
                                        if (match && match[1]) {
                                            input = input.replace(`:${match[1]}:`, "");
                                            input = input.replace(/\s+/g, ' ').trim();
                                            if(input[input.length - 1] === "|")
                                                input = input.slice(0, -1);
                                        }
                                        if(input.includes("|"))
                                            input += " :" + selectedDates+":";
                                        else
                                            input += "|:" + selectedDates+":";
                                    }
                                    else {
                                        input += "|:" + selectedDates + ":";
                                    }
                                }
                                if(keywordsSelected){
                                    if(input.includes("|")){
                                        const match = searchInput.match(/\*(.*?)\*/);
                                        if (match && match[1]) {
                                            input = input.replace(`*${match[1]}*`, "");
                                            input = input.replace(/\s+/g, ' ').trim();
                                            if(input[input.length - 1] === "|")
                                                input = input.slice(0, -1);
                                        }
                                        if(input.includes("|"))
                                            input += " *" + selectedKeywords?.map(k => k.Value).join(";")+"*";
                                        else
                                            input += "|*" + selectedKeywords?.map(k => k.Value).join(";")+"*";
                                    }
                                    else{
                                        input += "|*" + selectedKeywords?.map(k => k.Value).join(";")+"*";
                                    }
                                }
                                dispatch(updateQuickSearchFilter({
                                    ...quickSearchFilter,
                                    SearchCriterias: criterias
                                }));
                                historyPush(
                                    history,
                                    `/searchResults/${(input===null || input==="") ? "[all]" : input}/${randomID()}`
                                );
                            }}>
                                <FilterIcon />
                            </IconButton>
                        </BasicTooltip>
                        <Divider
                            orientation="vertical"
                            variant="fullWidth"
                            sx={{
                                height: 32,
                                m: "0px 8px",
                            }}
                        />
                        <BasicTooltip
                            title={t("common.GetResults")}
                            placement="top"
                        >
                            <IconButton
                                onClick={e => {
                                    const latestCriterias = quickSearchFilter?.SearchCriterias || criterias;
                                    const latestCategories = searchCategoriesImmediate || searchCategories;
                                    let input = searchText;
                                    input = input.replaceAll("/","-");
                                    const selectedKeywords = latestCriterias.find(c => c.value === "KeywordsOnly")?.selected;
                                    const keywordsSelected = selectedKeywords?.length > 0;
                                    const fileTypeChecked = latestCriterias.find(c => c.value === "FileType")?.checked;
                                    const stateChecked = latestCriterias.find(c => c.value === "State")?.checked;
                                    const categoryChecked = latestCriterias.find(c => c.value === "Category")?.checked;
                                    const rawStartDate = latestCriterias.find(c => c.value === "Date")?.startDate || startDate;
                                    const rawEndDate = latestCriterias.find(c => c.value === "Date")?.endDate || endDate;
                                    const formattedStartDate = rawStartDate ? dayjs(rawStartDate).format("DD-MM-YYYY") : "";
                                    const formattedEndDate = rawEndDate ? dayjs(rawEndDate).format("DD-MM-YYYY") : "";
                                    const dateSelected = formattedStartDate || formattedEndDate;

                                    const cleanInput = (str) => {
                                        return str
                                            .replace(/\|\s+/g, '|')
                                            .replace(/\s+$/g, '');
                                    };

                                    if(fileTypeChecked){
                                        let selectedFileType = latestCriterias.find(c => c.value === "FileType")?.selected;
                                        if(selectedFileType!==null){
                                            if(selectedFileType?.value){
                                                selectedFileType = selectedFileType.value;
                                            }
                                            if(selectedFileType?.startsWith(".")) selectedFileType = selectedFileType.substring(1);
                                            if(input.includes("|")){
                                                const match = searchInput.match(/\.(.*?)\./);
                                                if (match && match[1]) {
                                                    input = input.replace(`.${match[1]}.`, "");
                                                    input = input.replace(/\s+/g, ' ').trim();
                                                    if(input[input.length - 1] === "|") input = input.slice(0, -1);
                                                }
                                                if(input.includes("|"))
                                                    input += " ." + selectedFileType + ".";
                                                else
                                                    input += "|." + selectedFileType + ".";
                                            } else {
                                                input += "|." + selectedFileType + ".";
                                            }
                                        }
                                    }
                                    if(stateChecked){
                                        let selectedState = latestCriterias.find(c => c.value === "State")?.selected;
                                        if(selectedState?.value){
                                            selectedState = selectedState.value;
                                        }
                                        if(input.includes("|")){
                                            const match = searchInput.match(/\$(.*?)\$/);
                                            if (match && match[1]) {
                                                input = input.replace(`$${match[1]}$`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|") input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " $" + selectedState + "$";
                                            else
                                                input += "|$" + selectedState + "$";
                                        } else {
                                            input += "|$" + selectedState + "$";
                                        }
                                    }
                                    if(categoryChecked){
                                        let selectedCategory = latestCriterias.find(c => c.value === "Category")?.selected;
                                        if(selectedCategory?.value){
                                            selectedCategory = selectedCategory.value;
                                        }
                                        if(input.includes("|")){
                                            const match = searchInput.match(/\<(.*?)\>/);
                                            if (match && match[1]) {
                                                input = input.replace(`<${match[1]}>`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|") input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " <" + selectedCategory + ">";
                                            else
                                                input += "|<" + selectedCategory + ">";
                                        } else {
                                            input += "|<" + selectedCategory + ">";
                                        }
                                    }
                                    if(dateSelected){
                                        const selectedDates = formattedStartDate + ";" + formattedEndDate;
                                        if (input.includes("|")) {
                                            const match = searchInput.match(/\:(.*?)\:/);
                                            if (match && match[1]) {
                                                input = input.replace(`:${match[1]}:`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|") input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " :" + selectedDates + ":";
                                            else
                                                input += "|:" + selectedDates + ":";
                                        } else {
                                            input += "|:" + selectedDates + ":";
                                        }
                                    }
                                    if(keywordsSelected){
                                        if(input.includes("|")){
                                            const match = searchInput.match(/\*(.*?)\*/);
                                            if (match && match[1]) {
                                                input = input.replace(`*${match[1]}*`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|") input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " *" + selectedKeywords?.map(k => k.Value).join(";") + "*";
                                            else
                                                input += "|*" + selectedKeywords?.map(k => k.Value).join(";") + "*";
                                        } else {
                                            input += "|*" + selectedKeywords?.map(k => k.Value).join(";") + "*";
                                        }
                                    }

                                    dispatch(updateQuickSearchFilter({
                                        ...quickSearchFilter,
                                        SearchCriterias: latestCriterias,
                                        SearchCategories: latestCategories
                                    }));
                                    // Clear search results cache when starting a new search
                                    dispatch(clearSearchResults());
                                    historyPush(
                                        history,
                                        `/searchResults/${(input === null || input === "") ? "[all]" : input}/${randomID()}`
                                    );
                                }}
                            >
                                <SearchIcon />
                            </IconButton>
                        </BasicTooltip>
                    </>
                }
                placeholder={`${t("common.Search")}...`}
                inputProps={{ "aria-label": "search" }}
            />

            <Popper
                open={openPopper}
                anchorEl={anchorEl}
                sx={{ zIndex: 9999 }}
                placement="bottom"
                id={id}
            >
                <ClickAwayListener onClickAway={() => handlePopperClicAway()}>
                    {searchCategories[0]?.submenu?.length < 2 ?
                    <Paper
                        elevation={6}
                        sx={{
                            borderRadius: "0px 0px 8px 8px",
                            margin: "0px 66px 0px 0px",
                            padding: 2,
                            width: 500,
                            maxHeight: 350,
                            overflowY: "auto"
                        }}
                    >
                        <Box>
                            <Box
                                sx={{
                                    typography: "body2",
                                    textTransform: "uppercase",
                                }}
                            >
                                {t("common.QuickSearchInto")}
                            </Box>
                            <Box>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ flex: 3 }}>
                                        <FormControl sx={{ width: 200 }}>
                                            <FormControlLabel
                                                sx={{ mb:'-10px'}}
                                                control={
                                                    <Checkbox
                                                        name={searchCategories[0].label}
                                                        onChange={e => updateCategories(e)}
                                                        checked={searchCategories[0].checked}
                                                    />
                                                }
                                                label={t(`grid.title.${searchCategories[0].label}`)}
                                            />
                                            {searchCategories[0]?.submenu?.length > 0 && (
                                                <FormGroup sx={{ pl: 2 }}>
                                                    {searchCategories[0].submenu.map((branchItem, branchIndex) => (
                                                        <Box key={branchIndex}>
                                                            <Box
                                                                sx={{
                                                                    typography: "body1",
                                                                    pt: 1,
                                                                    cursor: "pointer",
                                                                    display: "flex",
                                                                    alignItems: "center"
                                                                }}
                                                                onClick={() =>
                                                                    setSelectedBranch(
                                                                        selectedBranch === branchItem.BranchCode
                                                                            ? null
                                                                            : branchItem.BranchCode
                                                                    )
                                                                }
                                                            >
                                                                {selectedBranch === branchItem.BranchCode ? (
                                                                    <ArrowDropDownIcon sx={{ mr: 1 }} />
                                                                ) : (
                                                                    <ArrowRightIcon sx={{ mr: 1 }} />
                                                                )}
                                                                {branchItem.BranchCode}
                                                            </Box>
                                                            {selectedBranch === branchItem.BranchCode &&
                                                                branchItem.Countries.map((countryItem, countryIndex) => (
                                                                    <Box sx={{ ml:3 }} key={countryIndex}>
                                                                        <Box sx={{ fontFamily:"arial", fontSize:"13px" }}>
                                                                        <FiberManualRecordIcon
                                                                            sx={{ fontSize:8, mr:1, color:"gray" }}
                                                                        />
                                                                            {countryItem.CountryName}
                                                                        </Box>
                                                                        {countryItem.OTEntities.map((subItem, subIndex) => (
                                                                            <FormControlLabel
                                                                                key={subIndex}
                                                                                control={
                                                                                    <Checkbox
                                                                                        name={subItem.Label}
                                                                                        onChange={(e) => updateCategories(e)}
                                                                                        checked={subItem.Checked}
                                                                                        sx={{ transform: "scale(0.9)" }}
                                                                                    />
                                                                                }
                                                                                label={subItem.Label}
                                                                                sx={{
                                                                                    "& .MuiFormControlLabel-label": {
                                                                                        fontSize: 11.8,
                                                                                    },
                                                                                    // mb: "-10px",
                                                                                    ml: 3
                                                                                }}
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                ))}
                                                        </Box>
                                                    ))}
                                                </FormGroup>
                                            )}
                                        </FormControl>
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        {searchCategories.slice(1).slice(0, -2).map((item, index) => (
                                            <FormControl key={index} sx={{ width: 160 }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={item.label}
                                                            onChange={e => updateCategories(e)}
                                                            checked={item.checked}
                                                        />
                                                    }
                                                    label={t(`grid.title.${item.label}`)}
                                                />
                                            </FormControl>
                                        ))}
                                        {searchCategories.slice(5).map((item, index) => (
                                            <FormControl key={index} sx={{ width: 160 }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name={item.label}
                                                            onChange={e => updateCategories(e)}
                                                            checked={item.checked}
                                                        />
                                                    }
                                                    label={t(`grid.title.${item.label}`)}
                                                />
                                            </FormControl>
                                        ))}
                                    </div>
                                </div>
                            </Box>
                            <Select
                                value={maxResultOptions.find(opt => opt.value === maxResultCount) || maxResultOptions[4]}
                                sx={{ mt: 2 }}
                                onChange={(event, data) =>
                                    updateMaxResultCount(event, data)
                                }
                                label={t("field.ResultsSize")}
                                options={maxResultOptions}
                            />
                        </Box>
                    </Paper>
                    :
                    newEntityTreeView ? (
                        <Paper
                            elevation={6}
                            sx={{
                                borderRadius: "0px 0px 8px 8px",
                                margin: "0px 66px 0px 0px",
                                padding: 2,
                                width: 500,
                                maxHeight: 350,
                                overflowY: "auto"
                            }}
                        >
                            <Box>
                                <Box
                                    sx={{
                                        typography: "body2",
                                        textTransform: "uppercase"
                                    }}
                                >
                                    {t("common.QuickSearchInto")}
                                </Box>
                                <Box>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ flex: 3 }}>
                                            <FormControl sx={{ width: 240 }}>
                                                <FormControlLabel
                                                    sx={{ mb:-1.4 }}
                                                    control={
                                                        <Checkbox
                                                            name={searchCategories[0].label}
                                                            onChange={e => updateCategories(e)}
                                                            checked={searchCategories[0].checked}
                                                        />
                                                    }
                                                    label={t(`grid.title.${searchCategories[0].label}`)}
                                                />
                                                {searchCategories[0]?.submenu?.length > 0 && (
                                                    <FormGroup sx={{ pl: 2 }}>
                                                        {searchCategories[0].submenu.map((branchItem, branchIndex) => (
                                                            <Box key={branchIndex}>
                                                                <Box
                                                                    sx={{
                                                                        typography: "body1",
                                                                        pt: 1,
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center"
                                                                    }}
                                                                    onClick={() => {
                                                                        setExpandedBranches(prev =>
                                                                            prev.includes(branchItem.BranchCode)
                                                                                ? prev.filter(code => code !== branchItem.BranchCode)
                                                                                : [...prev, branchItem.BranchCode]
                                                                        );
                                                                    }}
                                                                >
                                                                    <Checkbox
                                                                        size="small"
                                                                        name={branchItem.BranchCode}
                                                                        checked={branchItem.Checked || false}
                                                                        onChange={e => {
                                                                            e.stopPropagation();
                                                                            updateCategories(e);
                                                                        }}
                                                                        onClick={e => e.stopPropagation()}
                                                                        sx={{ mr: 1, p: 0.5 }}
                                                                    />
                                                                    <span>{branchItem.BranchCode}</span>
                                                                </Box>
                                                                {expandedBranches.includes(branchItem.BranchCode) && branchItem.Countries.map((countryItem, countryIndex) => (
                                                                        <Box sx={{ ml: 3.5, mb: 1.5 }} key={countryIndex}>
                                                                            <Box sx={{ display: "flex", alignItems: "center", fontFamily: "arial", fontSize: "13px" }}>
                                                                                <Checkbox
                                                                                    size="small"
                                                                                    name={countryItem.CountryName}
                                                                                    checked={countryItem.Checked || false}
                                                                                    onChange={e => updateCategories(e, branchItem.BranchCode) }
                                                                                    sx={{ mr: 1, p: 0.5 }}
                                                                                />
                                                                                <span>{countryItem.CountryName}</span>
                                                                            </Box>
                                                                            {countryItem.OTEntities.map((subItem, subIndex) => (
                                                                                <FormControlLabel
                                                                                    key={subIndex}
                                                                                    control={
                                                                                        <Checkbox
                                                                                            name={subItem.Label}
                                                                                            onChange={(e) => updateCategories(e)}
                                                                                            checked={subItem.Checked}
                                                                                            sx={{ transform: "scale(0.9)" }}
                                                                                        />
                                                                                    }
                                                                                    label={subItem.Label}
                                                                                    sx={{
                                                                                        "& .MuiFormControlLabel-label": {
                                                                                            fontSize: 11.8,
                                                                                        },
                                                                                        mb: "-15px",
                                                                                        ml: 3
                                                                                    }}
                                                                                />
                                                                            ))}
                                                                        </Box>
                                                                    ))}
                                                            </Box>
                                                        ))}
                                                    </FormGroup>
                                                )}
                                            </FormControl>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                        <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name={searchCategories[1].label}
                                                        onChange={e =>
                                                            updateCategories(e)
                                                        }
                                                        checked={searchCategories[1].checked}
                                                    />
                                                }
                                                label={t(
                                                    `grid.title.${searchCategories[1].label}`
                                                )}
                                            />
                                            {searchCategories.slice(2).map((item, index) => (
                                                <FormControl key={index} sx={{ width: 160 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                name={item.label}
                                                                onChange={e => updateCategories(e)}
                                                                checked={item.checked}
                                                            />
                                                        }
                                                        label={t(`grid.title.${item.label}`)}
                                                    />
                                                </FormControl>
                                            ))}
                                        </div>
                                    </div>
                                </Box>
                                <Select
                                    defaultValue={maxResultCount}
                                    sx={{ mt: 2 }}
                                    onChange={(event, data) =>
                                        updateMaxResultCount(event, data)
                                    }
                                    label={t("field.ResultsSize")}
                                    options={maxResultOptions}
                                />
                            </Box>
                        </Paper>)
                        :
                        (<Paper
                            elevation={6}
                            sx={{
                                borderRadius: "0px 0px 8px 8px",
                                margin: "0px 66px 0px 0px",
                                padding: 2,
                                width: 450,
                                maxHeight: 350,
                                overflowY: "auto"
                            }}
                        >
                            <Box>
                                <Box
                                    sx={{
                                        typography: "body2",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    {t("common.QuickSearchInto")}
                                </Box>
                                <Box>
                                    <div style={{ display: 'flex', minHeight: '220px' }}>
                                        <div style={{ flex: 3 }}>
                                            <FormControl
                                                sx={{ width: 160 }}
                                            >
                                                <FormControlLabel
                                                    sx={{ mb:-1.4}}
                                                    control={
                                                        <Checkbox
                                                            name={searchCategories[0].label}
                                                            onChange={e =>
                                                                updateCategories(e)
                                                            }
                                                            checked={searchCategories[0].checked}
                                                        />
                                                    }
                                                    label={t(
                                                        `grid.title.${searchCategories[0].label}`
                                                    )}
                                                />
                                                {searchCategories[0].submenu && (
                                                    <FormGroup sx={{ pl: 1 }}>
                                                        {searchCategories[0].submenu.map((subItem, subIndex) => (
                                                            <FormControlLabel
                                                                key={subIndex}
                                                                control={
                                                                    <Checkbox
                                                                        name={subItem.label}
                                                                        onChange={e => updateCategories(e)}
                                                                        checked={subItem.checked}
                                                                        sx={{ transform: "scale(0.9)" }}
                                                                    />
                                                                }
                                                                label={subItem.label}
                                                                sx={{
                                                                    "& .MuiFormControlLabel-label": {
                                                                        fontSize: "12px",
                                                                    },
                                                                    ml: 1,
                                                                    mb: "-15px"
                                                                }}
                                                            />
                                                        ))}
                                                    </FormGroup>
                                                )}
                                            </FormControl>
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <FormControlLabel
                                                // sx={{ mb:-1.4}}
                                                control={
                                                    <Checkbox
                                                        name={searchCategories[1].label}
                                                        onChange={e =>
                                                            updateCategories(e)
                                                        }
                                                        checked={searchCategories[1].checked}
                                                    />
                                                }
                                                label={t(
                                                    `grid.title.${searchCategories[1].label}`
                                                )}
                                            />
                                            {searchCategories.slice(2).map((item, index) => (
                                                <FormControl key={index} sx={{ width: 160 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                name={item.label}
                                                                onChange={e => updateCategories(e)}
                                                                checked={item.checked}
                                                            />
                                                        }
                                                        label={t(`grid.title.${item.label}`)}
                                                    />
                                                </FormControl>
                                            ))}
                                        </div>
                                    </div>
                                    <Select
                                        defaultValue={maxResultCount}
                                        sx={{ mt: 2 }}
                                        onChange={(event, data) =>
                                            updateMaxResultCount(event, data)
                                        }
                                        label={t("field.ResultsSize")}
                                        options={maxResultOptions}
                                    />
                                </Box>
                            </Box>
                        </Paper>
                    )}
                </ClickAwayListener>
            </Popper>
        </Box>
    );
};

export default SearchBar;
